export interface AiAnalysisScores {
  total: number;
  qualifications: number;
  experience: number;
  soft_skills: number;
  cultural_fit: number;
  potential: number;
}

export interface AiAnalysisResult {
  strengths: string[];
  weaknesses: string[];
  gaps: string[];
  matches: string[];
}

export interface AiCategoryDetail {
  score: number;
  max: number;
  percentage: number;
  rating: string;
  weight: number;
}

export interface AiDetailedReport {
  total_score: number;
  rating: string;
  percentage: number;
  categories: Record<string, AiCategoryDetail>;
}

export interface AiImprovementPriority {
  category: string;
  score: number;
  weight: number;
  impact: number;
  improvement_needed: boolean;
}

export interface AiAnalysis {
  scores: AiAnalysisScores;
  analysis: AiAnalysisResult;
  recommendations: string[];
  summary: string;
  detailed_report: AiDetailedReport;
  improvement_priorities: AiImprovementPriority[];
}

export interface AiAnalysisResponse {
  analysis: AiAnalysis;
  sanitized_text?: string;
}

export interface AiExportResponse {
  consultantId: string;
  generatedAt: string;
  original: Record<string, unknown>;
  sanitized: string;
  removedFields: string[];
}

export interface AiDiffHunk {
  id: number;
  tag: 'replace' | 'insert' | 'delete';
  diff: string;
  original_lines: string;
  improved_lines: string;
}

export interface AiImproveSummary {
  original_word_count: number;
  improved_word_count: number;
  change_percentage: number;
  original_score: number;
  focus_areas: string[];
  key_improvements: string[];
}

export interface AiImproveResponse {
  improved_profile: string;
  hunks: AiDiffHunk[];
  summary: AiImproveSummary;
}

export type HunkDecision = 'accepted' | 'rejected' | 'pending';

export interface AiApplyDecisionsResponse {
  finalProfile: string;
  finalProfileJson?: Record<string, unknown>;
  jsonConversionError?: string;
}

export enum Language {
  DE = 'de',
  EN = 'en'
}

export interface AiPromptsResponse {
  prompts: Record<string, string>;
}
